import { type FC } from "react";

import { ErrorLine } from "@styled/error_line";
import { LinkButton } from "@styled/link_button";
import { NoticeLine } from "@styled/notice_line";

import { useDraftingSectionsOf } from "./use_drafting_sections";

// The quiet line on a case whose copy of his template is older: when it
// changed and what, and Update this case; once updated, what changed here.
export const DraftingChangeLine: FC = () => {
  const drafting = useDraftingSectionsOf();

  if (drafting.updatedLine)
    return <NoticeLine>{drafting.updatedLine}</NoticeLine>;
  if (!drafting.changeLine) return null;

  return (
    <>
      <NoticeLine>
        {drafting.changeLine}{" "}
        <LinkButton onClick={() => void drafting.updateCase()}>
          {drafting.updatingCase ? "Updating…" : "Update this case"}
        </LinkButton>
      </NoticeLine>
      {drafting.caseUpdateError && (
        <ErrorLine>{drafting.caseUpdateError}</ErrorLine>
      )}
    </>
  );
};
